import { useEffect, useState } from "react";
import { BookOpen, MessageCircle, Search, Lightbulb, Thermometer, Sun, Layers, Receipt, Handshake, ArrowLeft } from "lucide-react";
import { api } from "../lib/api";

const CAT_ICON = {
  "Gesprächsführung": MessageCircle,
  "Bedarfsermittlung": Search,
  "Einwandbehandlung": Lightbulb,
  "Wärmepumpen-Grundlagen": Thermometer,
  "PV-Grundlagen": Sun,
  "PVT-Grundlagen": Layers,
  "Förderung": Receipt,
  "Abschlussgespräch": Handshake,
};

const Academy = () => {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/academy");
      setItems(data);
    })();
  }, []);

  if (active) {
    const Icon = CAT_ICON[active.category] || BookOpen;
    return (
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 animate-slide-up">
        <button onClick={() => setActive(null)} className="text-sm text-novatus-text-3 hover:text-novatus-green inline-flex items-center gap-1 mb-6" data-testid="academy-back-btn">
          <ArrowLeft className="w-4 h-4" /> Zurück zur Wissensbibliothek
        </button>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-xl bg-novatus-green/15 border border-novatus-green/40 flex items-center justify-center">
            <Icon className="w-6 h-6 text-novatus-green" />
          </div>
          <span className="text-[11px] uppercase tracking-[0.25em] font-semibold text-novatus-text-2 px-2.5 py-1 rounded-full bg-novatus-card-2 border border-novatus">{active.category}</span>
        </div>
        <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tight text-white">{active.title}</h1>
        <p className="text-novatus-text-2 mt-3 text-lg leading-relaxed">{active.summary}</p>
        <div className="nv-card mt-8 p-6 sm:p-8">
          <pre className="whitespace-pre-wrap font-sans text-[15px] leading-relaxed text-white">{active.content}</pre>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
      <div className="animate-slide-up">
        <span className="label-eyebrow">Academy-Wissen</span>
        <h1 className="font-display font-black text-3xl sm:text-5xl tracking-tight text-white mt-2">
          Lerne, was <span className="text-novatus-green">Profis</span> wissen.
        </h1>
        <p className="text-novatus-text-2 mt-3 max-w-2xl">
          Kompakte Grundlagen, Frameworks und Cheatsheets für deinen Vertrieb in Wärmepumpe, PV und PVT.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-9">
        {items.map((item, idx) => {
          const Icon = CAT_ICON[item.category] || BookOpen;
          return (
            <div
              key={item.id}
              className="nv-card nv-card-hover cursor-pointer p-6 animate-slide-up"
              style={{ animationDelay: `${idx * 0.04}s` }}
              onClick={() => setActive(item)}
              data-testid={`academy-item-${item.id}`}
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-lg bg-novatus-green/10 border border-novatus-green/30 flex items-center justify-center shrink-0">
                  <Icon className="w-5 h-5 text-novatus-green" />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-[10px] uppercase tracking-wider font-semibold text-novatus-text-3">{item.category}</span>
                  <h3 className="font-display font-bold text-lg text-white leading-tight mt-1">{item.title}</h3>
                  <p className="text-sm text-novatus-text-2 mt-2 leading-relaxed line-clamp-3">{item.summary}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Academy;
